import type { LoanDurationMaxParams } from '../types'

export const calculateLoanDuration = (
  loanAmount: number,
  extraLoanAmount: number,
  loanDuration: number,
  loanDurationMaxParams: LoanDurationMaxParams
) => {
  const totalLoanAmount = loanAmount + extraLoanAmount
  const loanDurationMax =
    totalLoanAmount <= loanDurationMaxParams.loanAmountBoundaryForDuration
      ? loanDurationMaxParams.loanDurationLowerMax
      : loanDurationMaxParams.loanDurationHigherMax
  if (loanDuration > loanDurationMax) {
    return loanDurationMax
  }
  return loanDuration
}
